import {Component, Vue, Prop} from 'vue-property-decorator';
import {BoxRequest, StatusKey as BoxRequestStatusKey} from "@/models/BoxRequest";
import {User} from "@/models/User";
import {AxiosError} from "axios";
import ErrorHandler from "@/support/ErrorHandler";

@Component<RequestEditDialog>({})
export default class RequestEditDialog extends Vue {
  @Prop()
  private value!: BoxRequest | null;

  protected stylists!: User[];
  protected stylistsLoaded: boolean = false;

  private async mounted(): Promise<void> {
    await this.fetchStylists();
  }

  private get statusses(): any[] {
    return Object.keys(BoxRequest.statuses).map((key: string): any => {
      return {
        value: key,
        text: BoxRequest.statuses[key as BoxRequestStatusKey],
      };
    });
  }

  protected async fetchStylists(): Promise<void> {
    this.stylists = await new User()
      .filter({
        role: 'stylist',
        is_active: true,
      })
      .sort('name')
      .limit(999)
      .all()
      .catch((error: AxiosError): User[] => {
        ErrorHandler.network(error);
        return [];
      });
    this.stylistsLoaded = true;
  }

  protected async update() {
    if (!this.value) {
      return;
    }

    const request: BoxRequest = await this.value
      .include('stylist')
      .update({
        stylist: this.value.stylist ? this.value.stylist.id : null,
        note: this.value.note,
        status: this.value.status,
      })
      .catch((error: AxiosError): null => {
        ErrorHandler.network(error);
        return null;
      });

    this.close();
  }

  protected close() {
    this.$emit('update:value', null);
  }
}
